module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Vully-les-Lacs_(Vaud)-c3189ce0838704641fe8f294859e5c82.svg";